module.exports = __webpack_public_path__ + "static/fonts/Fact-NarrowMedium.e523fe4.eot";